interface MissionVisionCardProps {
  title: string;
  description: string;
  onClick: () => void;
}

export default function MissionVisionCard({ title, description, onClick }: MissionVisionCardProps) {
  return (
    <div
      onClick={onClick}
      className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition-all cursor-pointer border border-gray-100 hover:border-brown-200"
    >
      <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  );
}